import { Flex } from "antd";
import { FC } from "react";

import DarkLogo from "@/assets/icons/logo-with-text-dark.svg";
import LightLogo from "@/assets/icons/logo-with-text-light.svg";
import { APP_VERSION, ENVIRONMENT } from "@/config";
import { useAppSelector } from "@/hooks/redux";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";
import { Theme } from "@/types";

import { CompanyLogo } from "./Styled";

interface AppIdentityProps {
    logoHeight?: number;
    showVersion?: boolean;
}

export const AppIdentity: FC<AppIdentityProps> = ({
    logoHeight = 125,
    showVersion = true,
}) => {
    const { type } = useAppSelector((s) => s.theme);

    const showEnvironment = ENVIRONMENT !== "prod";

    const isDarkTheme = type === Theme.DARK;

    const logo = isDarkTheme ? DarkLogo : LightLogo;

    return (
        <Flex vertical justify="center" align="center" gap={16}>
            <Flex vertical align="center">
                <CompanyLogo
                    src={logo}
                    alt="Company logo"
                    $logoHeight={logoHeight}
                />

                {showEnvironment && (
                    <PrimaryText
                        textColor={isDarkTheme ? "white" : "accent"}
                        fontSize={Math.floor(logoHeight / 11)}
                        fontWeight="800"
                        style={{
                            textTransform: "uppercase",
                            marginTop: -Math.floor(logoHeight / 10),
                        }}
                    >
                        {ENVIRONMENT}
                    </PrimaryText>
                )}
            </Flex>

            {showVersion && <SecondaryText>v{APP_VERSION}</SecondaryText>}
        </Flex>
    );
};
